<style type="text/css">
    .login {
        margin-left: 250px;
        margin-top: 100px;
    }
</style>
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
<app-header></app-header>
<div class="app-body">
    <app-sidebar *ngIf="loggedIn"></app-sidebar>
    <!-- Main content -->
    <main class="main">
        <!-- Breadcrumb -->
        <ol class="breadcrumb" *ngIf="loggedIn">
            <app-breadcrumbs></app-breadcrumbs>
        </ol>
        <div class="container-fluid" [ngClass]="(loggedIn) ? 'col-md-12':'col-md-5 col-md-offset-1 login'">
            <router-outlet></router-outlet>
        </div>
        <!-- /.conainer-fluid -->
    </main>
    <app-aside></app-aside>
</div>


// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/containers/full-layout/full-layout.component.html